import React, { ReactNode } from 'react'
import { Text, TextProps } from '@clear/design-system'

export type HeadingProps = TextProps & {
  children?: ReactNode
}

export const PageHeading = ({ children, ...props }: HeadingProps) => (
  <Text
    as="h1"
    variant="display"
    width="full"
    my={[6, 7]}
    color="brandDarkBlue"
    fontSize={[6, 8]}
    textAlign="center"
    __css={{
      textTransform: 'capitalize',
    }}
    {...props}
  >
    {children}
  </Text>
)

export const CardHeading = (props: HeadingProps) => (
  <PageHeading
    as="h2"
    my={[3, 4]}
    color="brandMidnightBlue"
    fontSize={[7, 8]}
    {...props}
  />
)
export const FormSectionHeading = (props: HeadingProps) => (
  <Text
    as="h3"
    variant="display"
    fontSize={5}
    my={3}
    color="brandMidnightBlue"
    {...props}
  />
)
